import { render, staticRenderFns } from "./historiesStaff.vue?vue&type=template&id=77395823&scoped=true"
import script from "./historiesStaff.vue?vue&type=script&lang=js"
export * from "./historiesStaff.vue?vue&type=script&lang=js"
import style0 from "./historiesStaff.vue?vue&type=style&index=0&id=77395823&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77395823",
  null
  
)

export default component.exports